module.exports = __webpack_public_path__ + "static/media/Access_Options@3x.f852352d.png";